module.exports = __webpack_public_path__ + "static/media/04.3b65f7fb.mp3";